import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "new-panarea" }
const _hoisted_2 = { class: "sidebar-topcontent" }
const _hoisted_3 = { class: "sort-price-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  "aria-label": "cta buttons",
  class: "cta__btn"
}

import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
  toRefs,
  inject,
} from 'vue';
import AppHeaderBreadcrumb from './AppHeaderBreadCrumb.vue';
import NeighborhoodList from './AppHeaderNeighborhoodList.vue';
import AppHeaderCommunityDetails from './AppHeaderCommunityDetails.vue';
import ArrowDownIcon from '@/assets/icons/ArrowDown.vue';
import { HomePlanSortOptions, QmiDaysFilter, Settings } from '@/constant';
import { isMobile, isTablet } from 'mobile-device-detect';
import LotSummary from './LotSummary.vue';

import type {
  CommunityQmiDetails,
  HeaderData,
  Lot,
  NeighboorhoodCoords,
  NeighborhoodInfo,
  NeighborhoodPlanQmiCounts,
  NeighborhoodPlatMap,
  NeighborhoodSoldDetails,
  QmiDays,
  Sibling,
  SidebarHomePlan,
  planDetails,
} from '../types';
import emitter from '@/mitt';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    coordinates: {},
    qmiDetails: {},
    headerData: {},
    availableSites: {},
    availablePlans: {},
    isKioskMode: { type: Boolean },
    messages: {},
    selectedLotId: {},
    selectedLotStatus: {},
    neighborhoods: {},
    selectedNeighborhoodIds: {},
    planPriceExsist: { type: Boolean },
    selectedSorting: {},
    qmiAndHomeplans: {},
    availableLots: {},
    soldPercentage: {},
    neighborhoodsPlanQmiCount: {},
    communityHomePlans: {},
    initialHomePlanCount: {},
    filterQmiCount: {},
    qmiAppliedMobile: { type: Boolean },
    sidebarOpen: { type: Boolean },
    homeTypeCount: {},
    totalMobileFilterApplied: {},
    showSelectedLotInformation: { type: Boolean },
    lotInformationData: {},
    communityName: {},
    areaName: {},
    homeplans: {},
    updateQmiData: { type: Function },
    showQmiPlans: { type: Function }
  },
  emits: [
  'filterPlanNameHomeType',
  'updateQmiFilterData',
  'setSorting',
  'setPlanNameListId',
  'loadNeighborhood',
  'applyMobileFilters',
  'setPlanDetailsHometypeList',
  'applyMobilePriceFilter',
  'sethoverNeighborZoomLevel',
  'selectNeighborhood',
  'hideSibling',
  'highlightNeighborhood',
  'clearSelectedNeighborhoods',
  'closeLotInfo',
  'toggleshowFilters',
  'showQmiHomeplans',
  'clearQmiDaysFilter',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {
  coordinates,
  qmiDetails,
  headerData,
  availableSites,
  availablePlans,
  isKioskMode,
  messages,
  selectedLotId,
  selectedLotStatus,
  neighborhoods,
  selectedNeighborhoodIds,
  planPriceExsist,
  selectedSorting,
  qmiAndHomeplans,
  availableLots,
  soldPercentage,
  neighborhoodsPlanQmiCount,
  communityHomePlans,
  initialHomePlanCount,
  filterQmiCount,
  qmiAppliedMobile,
  sidebarOpen,
  homeTypeCount,
  totalMobileFilterApplied,
  areaName,
  communityName,
  showSelectedLotInformation,
  lotInformationData,
} = toRefs(props);

const emit = __emit;
const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const qmiFilter = ref(false);
const qmiFilterList = ref<QmiDays[]>([]);
const initialQmiFilterList = ref<QmiDays[]>([]);
const hideSortQmiOption = ref(false);
const isAnyFilterApplied = ref(false);

const sortDropdown = ref(false);
const qmiDaysFilterDropdown = ref(false);
const homePlanSortOptions = HomePlanSortOptions;
const qmiDaysFilter = QmiDaysFilter;
const hasMobile = !!(isMobile && !isTablet);

const platmapCommunityDetails = ref<InstanceType<
  typeof AppHeaderCommunityDetails
> | null>(null);

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  isDisableHoverNeighbor: boolean;
  centerMap: NeighboorhoodCoords;
}) => {
  emit('sethoverNeighborZoomLevel', payload);
};
const loadNeighborhood = (payload: {
  areaName: string;
  communityName: string;
  neighborhoodName: string;
}) => {
  emit('loadNeighborhood', payload);
};
const hideSibling = () => {
  emit('hideSibling');
};
const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => {
  emit('highlightNeighborhood', payload);
};
const selectNeighborhood = (neighborhodId: string) => {
  emit('selectNeighborhood', neighborhodId);
};
const closeLotInfo = () => {
  emit('closeLotInfo');
};
const setSorting = (option: any) => {
  emit('setSorting', option);
};
const filterPlanNameHomeType = (payload: {
  listHomeType: string[];
  listPlanName: string[];
  maxPrice: number;
  minPrice: number;
}) => {
  const { listHomeType, listPlanName, maxPrice, minPrice } = payload;
  isAnyFilterApplied.value =
    !!listHomeType.length ||
    !!listPlanName.length ||
    maxPrice !== Settings.MaxValue ||
    minPrice !== Settings.MinValue;
  emit('filterPlanNameHomeType', payload);
};
const applyMobilePriceFilter = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  emit('applyMobilePriceFilter', payload);
};
const applyMobileFilters = (payload: {
  listPlanName: string[];
  listHomeType: string[];
  list: QmiDays[];
}) => {
  emit('applyMobileFilters', payload);
};
const toggleshowFilters = () => {
  emit('toggleshowFilters');
};
const setPlanNameListId = (listPlanNameId: string[]) => {
  emit('setPlanNameListId', listPlanNameId);
};
const clearSelectedNeighborhoods = () => {
  platmapCommunityDetails.value?.clearAllFilters?.();
  emit('clearSelectedNeighborhoods');
};
const showQmiHomeplans = (q: boolean) => {
  emit('showQmiHomeplans', q);
};
const clearQmiDaysFilter = (isQmiSelected: boolean) => {
  emit('clearQmiDaysFilter', isQmiSelected);
};
const setPlanDetailsHometypeList = (payload: {
  communityHomePlans: SidebarHomePlan[];
  homeTypeList: Set<string>;
  minPrice: number;
  maxPrice: number;
}) => {
  emit('setPlanDetailsHometypeList', payload);
};

const toggleDropdownVisibility = () => {
  if (!disableSortQmiFilter.value) sortDropdown.value = !sortDropdown.value;
};

const closeQmiFilter = () => {
  qmiDaysFilterDropdown.value = !qmiDaysFilterDropdown.value;
  qmiFilterList.value = [...initialQmiFilterList.value];
};

const qmiFilterUpdate = () => {
  if (!qmiFilter.value) {
    qmiFilterList.value = [];
  }
};

const hideDropDown = (e: Event) => {
  const dropdown = document.querySelector('.sort-price-container');
  const qmiFilterdropdown = document.querySelector('.qmi-filter');
  if (dropdown && !dropdown.contains(e.target as Node)) {
    sortDropdown.value = false;
  }
  if (qmiFilterdropdown && !qmiFilterdropdown.contains(e.target as Node)) {
    qmiFilterList.value = [...initialQmiFilterList.value];
    qmiDaysFilterDropdown.value = false;
  }
};

const applyMoveInDaysFilter = () => {
  if (qmiFilterList.value.length) {
    qmiFilter.value = true;
    qmiDaysFilterDropdown.value = false;
    initialQmiFilterList.value = [...qmiFilterList.value];
    let qmiArray: any[] = props.updateQmiData(qmiFilterList.value);
    emit('updateQmiFilterData', qmiArray);
  }
};

const checkSubFilters = () => {
  hideSortQmiOption.value = false;
  if (selectedNeighborhoodIds.value.length) {
    const currentNeighborhoodData = soldPercentage.value.find(
      (neighborhood) =>
        neighborhood.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    if (currentNeighborhoodData) {
      hideSortQmiOption.value = !!(
        currentNeighborhoodData.totalLotsCount === 0 ||
        initialHomePlanCount.value === 0
      );
    } else {
      hideSortQmiOption.value = true;
    }
  } else {
    if (soldPercentage.value.length !== neighborhoods.value.length) {
      hideSortQmiOption.value = true;
    } else {
      const lotsHomePlans = soldPercentage.value.find(
        (neighborhood) =>
          neighborhood.totalLotsCount && initialHomePlanCount.value
      );
      hideSortQmiOption.value = !lotsHomePlans;
    }
  }
};

const clearMoveInDaysFilter = () => {
  qmiFilterList.value = [];
  initialQmiFilterList.value = [];
  qmiFilter.value = false;
  clearQmiDaysFilter(qmiFilter.value);
};

const applyUrlQmi = (list: QmiDays[]) => {
  qmiFilterList.value = list;
  applyMoveInDaysFilter();
};

const changeQmifilterSelectedNeighborhoodIds = computed(
  () => `${qmiFilter.value} ${selectedNeighborhoodIds.value}`
);

const disableSortQmiFilter = computed(() => {
  if (!selectedNeighborhoodIds.value.length) {
    const totalLots = soldPercentage.value.filter(
      (each) => !each.totalLotsCount
    );
    return (
      !initialHomePlanCount.value ||
      totalLots.length === soldPercentage.value.length
    );
  } else {
    const currentNeighborhoodTotalCount = soldPercentage.value.filter(
      (each) => each.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    return (
      !initialHomePlanCount.value ||
      !currentNeighborhoodTotalCount[0]?.totalLotsCount
    );
  }
});
const neighborhoodLotsCount = (neighborhoodId: string) => {
  return (
    soldPercentage.value.find((p) => p.neighborhoodId === neighborhoodId)
      ?.totalLotsCount || 0
  );
};

const isComingSoon = (sibling: Sibling) =>
  sibling.nb_unit_status?.toLowerCase().includes('coming soon');

watch(changeQmifilterSelectedNeighborhoodIds, () => {
  if (!qmiFilterList.value.length) {
    let qmiArray: any[] = props.showQmiPlans(qmiFilter.value);
    emit('updateQmiFilterData', qmiArray);
  }
  if (qmiFilter.value && !qmiFilterList.value.length) {
    qmiFilterList.value = [...qmiDaysFilter];
    initialQmiFilterList.value = [...qmiDaysFilter];
    applyMoveInDaysFilter();
  } else if (!qmiFilter.value) {
    qmiFilterList.value = [];
    initialQmiFilterList.value = [];
    let qmiArray: any[] = props.showQmiPlans(false);
    emit('updateQmiFilterData', qmiArray);
  } else {
    applyMoveInDaysFilter();
  }
});

watch(soldPercentage, () => {
  checkSoldFilters();
});

const checkSoldFilters = () => {
  checkSubFilters();
};

watch(selectedNeighborhoodIds, () => {
  checkFilters();
});

const checkFilters = () => {
  checkSubFilters();
};

watch(sidebarOpen, () => {
  if (hasMobile) {
    const el = document.getElementsByClassName('new-panarea')[0] as
      | HTMLElement
      | undefined;
    if (el) {
      el.addEventListener('touchstart', () => {
        toggleshowFilters();
      });
    }
  }
});

const resetSelectedSorting = () => {
  clearMoveInDaysFilter();
  if(homePlanSortOptions.length) {
    setSorting(homePlanSortOptions[0])
  }
};

onMounted(() => {
  emitter.on('communityUpdated', resetSelectedSorting);
  emitter.on('newDivisonSelected', resetSelectedSorting);
  checkSubFilters();
  if (hasMobile) {
    const el = document.getElementsByClassName('new-panarea')[0] as
      | HTMLElement
      | undefined;
    if (el) {
      el.addEventListener('touchstart', () => {
        toggleshowFilters();
      });
    }
  }
  window.addEventListener('click', hideDropDown);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', hideDropDown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pan-area" }, null, -1)),
      (!_unref(isSalesOrLandView))
        ? (_openBlock(), _createBlock(AppHeaderBreadcrumb, {
            key: 0,
            areaUrl: _unref(headerData).area_url,
            communityUrl: _unref(headerData).community_url,
            communityName: _unref(headerData).community_name,
            communityEnabled: _unref(headerData).community_enabled,
            neighborhoods: _unref(headerData).sibling,
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            isKioskMode: _unref(isKioskMode)
          }, null, 8, ["areaUrl", "communityUrl", "communityName", "communityEnabled", "neighborhoods", "selectedNeighborhoodIds", "isKioskMode"]))
        : _createCommentVNode("", true),
      _createVNode(AppHeaderCommunityDetails, {
        ref_key: "platmapCommunityDetails",
        ref: platmapCommunityDetails,
        headerData: _unref(headerData),
        areaName: _unref(areaName),
        communityName: _unref(communityName),
        availableSites: _unref(availableSites),
        availableLots: _unref(availableLots),
        availablePlans: _unref(availablePlans),
        qmiAndHomeplans: _unref(qmiAndHomeplans),
        qmiAppliedMobile: _unref(qmiAppliedMobile),
        neighborhoodsPlanQmiCount: _unref(neighborhoodsPlanQmiCount),
        selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
        qmiDetails: _unref(qmiDetails),
        communityHomePlans: _unref(communityHomePlans),
        qmiFilter: qmiFilter.value,
        filterQmiCount: _unref(filterQmiCount),
        soldPercentage: _unref(soldPercentage),
        initialHomePlanCount: _unref(initialHomePlanCount),
        homeTypeCount: _unref(homeTypeCount),
        planPriceExsist: _unref(planPriceExsist),
        neighborhoodLotsCount: neighborhoodLotsCount,
        isComingSoon: isComingSoon,
        onSelectNeighborhood: selectNeighborhood,
        onFilterPlanNameHomeType: filterPlanNameHomeType,
        onSetPlanNameListId: setPlanNameListId,
        onLoadNeighborhood: loadNeighborhood,
        onSetPlanDetailsHometypeList: setPlanDetailsHometypeList,
        onSetSorting: setSorting,
        onApplyUrlQmi: applyUrlQmi,
        onApplyMobileFilters: applyMobileFilters,
        onApplyMobilePriceFilter: applyMobilePriceFilter
      }, null, 8, ["headerData", "areaName", "communityName", "availableSites", "availableLots", "availablePlans", "qmiAndHomeplans", "qmiAppliedMobile", "neighborhoodsPlanQmiCount", "selectedNeighborhoodIds", "qmiDetails", "communityHomePlans", "qmiFilter", "filterQmiCount", "soldPercentage", "initialHomePlanCount", "homeTypeCount", "planPriceExsist"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (
            Object.keys(_unref(lotInformationData)).length && _unref(showSelectedLotInformation)
          )
          ? (_openBlock(), _createBlock(LotSummary, {
              key: 0,
              lotInformationData: _unref(lotInformationData)
            }, null, 8, ["lotInformationData"]))
          : _createCommentVNode("", true)
      ]),
      (_unref(headerData).community_name)
        ? (_openBlock(), _createBlock(NeighborhoodList, {
            key: 0,
            siblings: _unref(headerData).sibling,
            soldPercentage: _unref(soldPercentage),
            neighborhoods: _unref(neighborhoods),
            neighborhoodsPlanQmiCount: _unref(neighborhoodsPlanQmiCount),
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            qmiFilter: qmiFilter.value,
            isAnyFilterApplied: isAnyFilterApplied.value,
            totalMobileFilterApplied: _unref(totalMobileFilterApplied),
            coordinates: _unref(coordinates),
            neighborhoodLotsCount: neighborhoodLotsCount,
            isComingSoon: isComingSoon,
            onSelectNeighborhood: selectNeighborhood,
            onLoadNeighborhood: loadNeighborhood,
            onClearSelectedNeighborhoods: clearSelectedNeighborhoods,
            onHideSibling: hideSibling,
            onHighlightNeighborhood: highlightNeighborhood,
            onSethoverNeighborZoomLevel: sethoverNeighborZoomLevel
          }, null, 8, ["siblings", "soldPercentage", "neighborhoods", "neighborhoodsPlanQmiCount", "selectedNeighborhoodIds", "qmiFilter", "isAnyFilterApplied", "totalMobileFilterApplied", "coordinates"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['fw-ic-jb mb-20', { hide: hideSortQmiOption.value }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Sort :", -1)),
          _createElementVNode("div", {
            class: "relative",
            onClick: toggleDropdownVisibility
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(['sort-price-btn', { disableSort: disableSortQmiFilter.value }])
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(selectedSorting)), 1),
              _createVNode(ArrowDownIcon, {
                class: _normalizeClass({ 'rotate-180': sortDropdown.value })
              }, null, 8, ["class"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(['dropdown', { show: sortDropdown.value }])
            }, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homePlanSortOptions), (option, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: idx,
                    class: _normalizeClass([
                    'dropdown-item',
                    { 'is-selected': option.value === _unref(selectedSorting) },
                  ]),
                    onClick: ($event: any) => (setSorting(option))
                  }, _toDisplayString(option.value), 11, _hoisted_4))
                }), 128))
              ])
            ], 2)
          ])
        ]),
        (!hasMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
            'qmi-filter form-check',
            { disableSort: disableSortQmiFilter.value },
          ])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((qmiFilter).value = $event)),
                class: "form-check-input",
                id: "qmi",
                onClick: qmiFilterUpdate
              }, null, 512), [
                [_vModelCheckbox, qmiFilter.value]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "qmi",
                class: "form-check-label"
              }, null, -1)),
              _createElementVNode("button", {
                class: "sort-price-btn",
                onClick: closeQmiFilter
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Quick Move-in", -1)),
                _createVNode(ArrowDownIcon, {
                  class: _normalizeClass({ 'rotate-180': qmiDaysFilterDropdown.value })
                }, null, 8, ["class"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['dropdown mr-auto', { show: qmiDaysFilterDropdown.value }])
              }, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qmiDaysFilter), (option, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "dropdown-item",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: option.value,
                          value: option,
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((qmiFilterList).value = $event))
                        }, null, 8, _hoisted_6), [
                          [_vModelCheckbox, qmiFilterList.value]
                        ]),
                        _createElementVNode("label", {
                          for: option.value,
                          class: "form-check-label"
                        }, _toDisplayString(option.value), 9, _hoisted_7)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "cta__btntext",
                    onClick: clearMoveInDaysFilter
                  }, " Clear "),
                  _createElementVNode("button", {
                    class: _normalizeClass([
                  'cta__btnsolid',
                  { disableApplyButton: !qmiFilterList.value.length },
                ]),
                    onClick: applyMoveInDaysFilter
                  }, " Apply ", 2)
                ])
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 64))
}
}

})